<template>
    <div>
      <b-pagination
        :total-rows="totalRows"
        :per-page="perPage"
        class="my-pag"
        @change="currentPageChanged"
        limit=10
        />
    </div>
</template>

<style>
.nav-pills:not(.nav-pills-icons) > li > a {
  border-radius: 0.2rem !important;
}

.nav-pills .nav-link:not(.active) {
  color: #343a40 !important;
  text-align: left;
  font-size: 1em;
}

.nav-pills .nav-link.active {
  background-color: #17a2b8 !important;
  color: white !important;
  text-align: left;
  font-size: 1.2em;
}

.page-item.active .page-link {
  background-color: #17a2b8 !important;
  border-color: #17a2b8 !important;
}
</style>

<script>
export default {
  props: ['totalRows', 'perPage'],
  methods: {
    currentPageChanged (value) {
      this.$emit('input', value)
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/tables/TableManagerBottom.vue